import React from 'react';
import './Contact.css';
import Navbar from '../Navbar/Navbar';
import FAQ from '../FAQ/FAQ';
import Swal from 'sweetalert2'


const ContactUs = () => {
  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    formData.append("access_key", "7ab2f73b-81ef-47da-9df7-85064dbb338c");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: json
    }).then((res) => res.json());

    if (res.success) {
      Swal.fire({
        title: "Success!",
        text: "Message sent successfully!",
        icon: "success"
      });
    }
  };

  return (
    <div className="contact-us-container">
      <div className="contact-top">
        <Navbar />
        <div className="contact-first">
          <div className="contact-info">
            <div className="top-section">
              <h2>Contact Us</h2>
              <p>Email, call, or complete the form to learn how Vedant Enterprises can streamline your logistics needs.</p>
              <a href="mailto:contactus@vedantenterprisesglb.com">
                <p>contactus@vedantenterprisesglb.com</p>
              </a>
              <a href="tel:+918310427583">
                <p>+91-8310427583</p>
              </a>
              <p>Kalaburagi, Pallapur, Karnataka 585101</p>
            </div>

            <div className="additional-info">
              <div>
                <h4>Customer Support</h4>
                <p>Our dedicated team is available round the clock to handle your logistics inquiries or concerns.</p>
              </div>
              <div>
                <h4>Feedback and Suggestions</h4>
                <p>We value your feedback to help improve our warehousing, transportation & delivery services.</p>
              </div>
              <div>
                <h4>Media Inquiries</h4>
                <p>For media or press-related queries, reach us at contactus@vedantenterprisesglb.com</p>
              </div>
            </div>
          </div>

          <div className="contact-form">
            <p>Get in Touch</p>
            <h1>You can reach us anytime</h1>
            <form onSubmit={onSubmit}>
              <div className="form-row">
                <input type="text" placeholder="First name" name='fname' required />
                <input type="text" placeholder="Last name" name='lname' required />
              </div>
              <input type="email" placeholder="Your email" name='email' required />
              <div className="form-row">
                <select>
                  <option value="+91">+91</option>
                </select>
                <input type="tel" placeholder="Phone number" name="number" required />
              </div>
              <textarea placeholder="How can we help?" name='message' maxLength="120"></textarea>
              <button type="submit">Submit</button>
              <p className="terms">
                By contacting us, you agree to our <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>.
              </p>
            </form>
          </div>
        </div>
      </div>
      <div className="location">
        <div className="contact-map" >
          <iframe
            title="Vedant Enterprises Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3807.778995381813!2d76.7948979!3d17.374364399999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc8b94e37203169%3A0xe7b9acd53e0ad0d2!2sVEDANT%20ENTERPRISES!5e0!3m2!1sen!2sin!4v1749130984565!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <div className="location-details">
          <div className="head-loc">
            <p>Our Location</p>
            <h1>Connecting Near and Far</h1>
          </div>
          <div className="adress-loc">
            <h2>Headquarters</h2>
            <p>Kalaburagi, Pallapur,Karnataka 585101</p>
          </div>
        </div>

      </div>
      <FAQ />
    </div>
  );
};

export default ContactUs;
